import * as Yup from 'yup'

import CallToActionButton from 'components/common/CallToActionButton/CallToActionButton'
import React from 'react'
import SimpleInput from 'components/common/SimpleInput/SimpleInput'
import { THEME_LIGHT } from 'constants.js'
import { useForm } from 'hooks/use-form'
import { useStyles } from './styles'

const validationSchema = Yup.object().shape({
    email: Yup.string()
        .email('Please enter a valid email address')
        .required('Please provide a display name'),
})

export const PriorityListForm = ({ artist, createPriorityListUser, creationError, ipv4, refCode }) => {
    const submitEmailHandler = async ({ email }) =>
        await createPriorityListUser(artist._id, { email, ipv4, ...(refCode && { refCode }) })

    const { values, handleSubmit, eventHandlers, errors, touched } = useForm(
        'prioritylist',
        { email: '' },
        submitEmailHandler,
        validationSchema,
    )
    const classes = useStyles()

    return (
        <div className={classes.container}>
            <p className={classes.headline}>Get first access.</p>
            <p className={classes.headlineDesc}>
                Join my priority list to get first access to a paid ticketed live stream event. My team and I are
                putting together an interactive variety show that involves you guys. If you sign up below, you will be
                the first to get notified when tickets go on sale.
            </p>

            <p className={classes.emailDisclaimer}>
                (Don't worry. We'll only send you emails related to this {artist.name} experience)
            </p>
            <form className={classes.formInline} onSubmit={handleSubmit}>
                <SimpleInput
                    error={creationError || (touched.email && errors.email)}
                    onChange={eventHandlers.email}
                    value={values.email}
                    label=""
                    placeholder="Email"
                    className={classes.formCtrlInline}
                    themeColor={THEME_LIGHT}
                />
                <CallToActionButton onClick={handleSubmit} type="primary" display="inline" text="Join priority list" />
                <input style={{ display: 'none' }} type="submit" />
            </form>
        </div>
    )
}

export default React.memo(PriorityListForm)
